'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = require('react'); //eslint-disable-line no-unused-vars
var ReactDOM = require('react-dom');
var PropTypes = require('prop-types');

var iframeStyle = {
	width: '100%',
	height: '300px'
};

var JotformEmbed = function (_React$Component) {
	(0, _inherits3.default)(JotformEmbed, _React$Component);

	function JotformEmbed(props) {
		(0, _classCallCheck3.default)(this, JotformEmbed);

		var _this = (0, _possibleConstructorReturn3.default)(this, (JotformEmbed.__proto__ || (0, _getPrototypeOf2.default)(JotformEmbed)).call(this, props));

		_this.handleIframeMessage = _this.handleIframeMessage.bind(_this);
		return _this;
	}

	(0, _createClass3.default)(JotformEmbed, [{
		key: 'handleIframeMessage',
		value: function handleIframeMessage(e) {
			var props = this.props;
			if (!e.data.split) {
				return;
			}
			var args = e.data.split(':');
			var formId = args[2];
			var iframe = ReactDOM.findDOMNode(this.refs.iframe);
			if (!!iframe && (!formId || props.src.endsWith(formId))) {
				switch (args[0]) {
					case 'scrollIntoView':
						iframe.scrollIntoView();
						break;
					case 'setHeight':
						iframe.style.height = args[1] + 'px';
						break;
					case 'collapseErrorPage':
						if (iframe.clientHeight > global.innerHeight) {
							iframe.style.height = global.innerHeight + 'px';
						}
						break;
					case 'reloadPage':
						global.location.reload();
						break;
				}
				var isJotForm = e.origin.indexOf('jotform') > -1;
				if (isJotForm && 'contentWindow' in iframe && 'postMessage' in iframe.contentWindow) {
					var urls = {
						'docurl': encodeURIComponent(global.document.URL),
						'referrer': encodeURIComponent(global.document.referrer)
					};
					iframe.contentWindow.postMessage((0, _stringify2.default)({ 'type': 'urls', 'value': urls }), '*');
				}
			}
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			if (global.addEventListener) {
				global.addEventListener('message', this.handleIframeMessage, false);
			} else if (global.attachEvent) {
				global.attachEvent('onmessage', this.handleIframeMessage);
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (global.removeEventListener) {
				global.removeEventListener('message', this.handleIframeMessage, false);
			} else if (global.detachEvent) {
				global.detachEvent('onmessage', this.handleIframeMessage);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var props = this.props;
			return React.createElement('iframe', { ref: 'iframe', style: iframeStyle, className: props.className, src: props.src, frameBorder: 0, scrolling: 'no' });
		}
	}, {
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps) {
			var props = this.props;
			return props.src !== nextProps.src || props.className !== nextProps.className;
		}
	}]);
	return JotformEmbed;
}(React.Component);

JotformEmbed.propTypes = {
	src: PropTypes.string.isRequired,
	className: PropTypes.string
};
exports.default = JotformEmbed;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jotform-embed/lib/react-jotform-embed.js
// module id = 69
// module chunks = 0